module.exports = __webpack_public_path__ + "static/media/70.41cde4ac.png";